import PropTypes from 'prop-types'
import { makeFormPropTypes } from '../../../common/formikPropTypes'
import { shippingSend2ToPropTypes } from '../../../common/propTypes'

import FormLayout from './FormLayout'

import AddressSection from './AddressSection'

const Step2Destination = props => {
  return (
    <FormLayout>
      <AddressSection {...props} isDestination />
    </FormLayout>
  )
}

Step2Destination.propTypes = {
  ...makeFormPropTypes(shippingSend2ToPropTypes),
  isCenterWithAddressesBook: PropTypes.bool,
  onClickOpenAgenda: PropTypes.func.isRequired,
  onChangeAutocompleteAddress: PropTypes.func,
  onTouchAutocompleteAddress: PropTypes.func,
}

export default Step2Destination
